/**
 * Copy text to the clipboard, working on BOTH https and plain http.
 *
 * The async Clipboard API (navigator.clipboard) only works in a "secure
 * context" (https or localhost). On a plain http:// site (like the GCP IP)
 * it's unavailable, so copy buttons silently fail. This helper falls back to
 * the legacy hidden-textarea + execCommand('copy') method in that case.
 *
 * Returns true on success, false otherwise.
 */
export async function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      /* fall through to the legacy method */
    }
  }
  try {
    const ta = document.createElement('textarea')
    ta.value = text
    ta.setAttribute('readonly', '')
    ta.style.position = 'fixed'
    ta.style.left = '-9999px'
    ta.style.opacity = '0'
    document.body.appendChild(ta)
    ta.focus()
    ta.select()
    const ok = document.execCommand('copy')
    document.body.removeChild(ta)
    return ok
  } catch {
    return false
  }
}
